import { isDesktop, isMobile, isTablet } from '@theme/utilities';

/**
 * @param {HTMLElement} root
 */
function showFloatingAtc(root) {
  root.classList.add('product-floating-atc--visible');
  root.classList.remove('product-floating-atc--hidden');
  root.setAttribute('aria-hidden', 'false');
}

/**
 * @param {HTMLElement} root
 */
function hideFloatingAtc(root) {
  root.classList.remove('product-floating-atc--visible');
  root.classList.add('product-floating-atc--hidden');
  root.setAttribute('aria-hidden', 'true');
}

/**
 * @param {string | undefined} value
 * @param {number} fallback
 * @returns {number}
 */
function parseOffset(value, fallback) {
  const offset = Number.parseInt(value ?? '', 10);
  return Number.isFinite(offset) ? offset : fallback;
}

/**
 * @param {HTMLElement} root
 * @returns {number}
 */
function getScrollOffset(root) {
  if (isMobile()) {
    return parseOffset(root.dataset.scrollOffsetMobile, 200);
  }

  if (isTablet()) {
    return parseOffset(root.dataset.scrollOffsetTablet, 300);
  }

  if (isDesktop()) {
    return parseOffset(root.dataset.scrollOffsetDesktop, 400);
  }

  return parseOffset(root.dataset.scrollOffsetMobile, 200);
}

/**
 * @param {HTMLElement} root
 */
function initProductFloatingAtc(root) {
  if (root.dataset.floatingAtcInitialized === 'true') return;

  root.dataset.floatingAtcInitialized = 'true';

  const abortController = new AbortController();
  const { signal } = abortController;
  let scrollFrame = 0;

  const updateVisibility = () => {
    const threshold = getScrollOffset(root);

    if (window.scrollY > threshold) {
      showFloatingAtc(root);
    } else {
      hideFloatingAtc(root);
    }
  };

  const onScroll = () => {
    if (scrollFrame) {
      window.cancelAnimationFrame(scrollFrame);
    }

    scrollFrame = window.requestAnimationFrame(updateVisibility);
  };

  window.addEventListener('scroll', onScroll, { passive: true, signal });
  window.addEventListener('resize', updateVisibility, {
    passive: true,
    signal,
  });
  updateVisibility();
}

/**
 * @param {ParentNode} scope
 */
function initFloatingAtcInScope(scope) {
  scope.querySelectorAll('[data-product-floating-atc]').forEach((root) => {
    if (root instanceof HTMLElement) {
      initProductFloatingAtc(root);
    }
  });
}

initFloatingAtcInScope(document);

document.addEventListener('shopify:section:load', (event) => {
  if (!(event.target instanceof HTMLElement)) return;
  initFloatingAtcInScope(event.target);
});
